import { motion } from "motion/react";
import { companyDescription, coreCompetencies } from "@/mocks/home";

export default function CompanySection() {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          {/* Left: Company Info */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="flex-1"
          >
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
              About Fiber One
            </h2>
            <div className="w-16 h-1 bg-accent rounded-full mb-6"></div>
            <div className="text-sm md:text-base text-gray-600 leading-relaxed space-y-4 whitespace-pre-line">
              {companyDescription}
            </div>
          </motion.div>

          {/* Right: Core Competencies mini list */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="lg:w-96 flex-shrink-0"
          >
            <div className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-100">
              <h3 className="text-lg font-bold text-gray-900 mb-5">
                Core Competencies
              </h3>
              <div className="space-y-3">
                {coreCompetencies.map((item, index) => (
                  <motion.div
                    key={item.title}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.3 + index * 0.08 }}
                    whileHover={{ x: 4 }}
                    className="flex items-center gap-3 cursor-default"
                  >
                    <motion.div
                      whileHover={{ scale: 1.2, rotate: 10 }}
                      transition={{ type: "spring", stiffness: 400 }}
                      className="w-8 h-8 flex items-center justify-center rounded-full bg-primary flex-shrink-0"
                    >
                      <i className={`${item.icon} text-accent text-sm`}></i>
                    </motion.div>
                    <span className="text-sm font-medium text-gray-700">
                      {item.title}
                    </span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}